/**
 * Props accepted by {@link TaskPlusIcon}.
 */
interface TaskPlusIconProps {
  className?: string;
  width?: number;
  height?: number;
  stroke?: string;
  strokeWidth?: number;
}

/**
 * Renders the plus icon used in task action buttons.
 *
 * @param props - Optional style and sizing props for the icon.
 * @returns SVG plus icon for create-task actions.
 */
const TaskPlusIcon = ({
  className,
  width = 20,
  height = 20,
  stroke = "black",
  strokeWidth = 0.8,
}: TaskPlusIconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      className={className}
    >
      <path
        d="M9.6 4V15.2M4 9.6H15.2"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default TaskPlusIcon;
